import { createContext, useContext, type InputHTMLAttributes, type TextareaHTMLAttributes, type SelectHTMLAttributes } from 'react';

export const SowErrorsContext = createContext<Record<string, string>>({});

function useField(name?: string) {
  const errors = useContext(SowErrorsContext);
  const error = name ? errors[name] : undefined;
  return { error, errorId: name ? `sow-error-${name}` : undefined };
}

export function SowInput(props: InputHTMLAttributes<HTMLInputElement>): JSX.Element {
  const { error, errorId } = useField(props.name);
  return <><input {...props} aria-invalid={!!error} aria-describedby={error ? errorId : props['aria-describedby']} />{error && <span id={errorId} role="alert" style={{ color: 'var(--warn)', display: 'block', fontSize: 12 }}>{error}</span>}</>;
}
export function SowTextarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>): JSX.Element {
  const { error, errorId } = useField(props.name);
  return <><textarea {...props} aria-invalid={!!error} aria-describedby={error ? errorId : props['aria-describedby']} />{error && <span id={errorId} role="alert" style={{ color: 'var(--warn)', display: 'block', fontSize: 12 }}>{error}</span>}</>;
}
export function SowSelect(props: SelectHTMLAttributes<HTMLSelectElement>): JSX.Element {
  const { error, errorId } = useField(props.name);
  return <><select {...props} aria-invalid={!!error} aria-describedby={error ? errorId : props['aria-describedby']} />{error && <span id={errorId} role="alert" style={{ color: 'var(--warn)', display: 'block', fontSize: 12 }}>{error}</span>}</>;
}
